///jacques-andre-editeur\proshop-v2\frontend\src\screens\BooksScreen.jsx
import { Container } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useGetBooksQuery } from '../slices/booksApiSlice';
import { FaSort } from 'react-icons/fa';
import BookCard from '../components/BookCard';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Paginate from '../components/Paginate';
import Meta from '../components/Meta';
import { useState } from 'react';

const BooksScreen = () => {

  const params = useParams();

  const pageNumber = parseInt(params.pageNumber) || 1;  // Directement extrait des params
  const keyword = params.keyword || '';

  const parPage = 22;

  const [sortConfig, setSortConfig] = useState({
      key: 'numeroEditeur', // Tri initial par ObjectId
      direction: 'desc', // Ordre décroissant par défaut
    });

  const { data, isLoading, error, refetch } = useGetBooksQuery({
    keyword,
    pageNumber,
    parPage,
    sortKey: sortConfig.key,
    sortDirection: sortConfig.direction
  });
  
  // Fonction pour changer le tri
  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key
      ? (prev.direction === 'asc' ? 'desc' : 'asc')
      : (prev.key === 'numeroEditeur' ? 'asc' : 'desc'),
    }));
    refetch();
  };


  return (
    <div>
      <Meta />
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>
          {error?.data?.message || error.error}
        </Message>
      ) : (
        <Container>
          <div className="h1-container">
            <h1>Tous nos livres</h1>
            <div className="mh-3">
              <button
                className="btn btn-outline-secondary me-2"
                onClick={() => handleSort('booksCollection')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
              >
                Trier par collection <FaSort />
              </button>
            </div>
              <div className="mh-3">
                <button
                  className="btn btn-outline-secondary me-2"
                  onClick={() => handleSort('numeroEditeur')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                >
                  Trier par ordre de parution <FaSort />
                </button>
              </div>
          </div>

          {pageNumber === 1 ? (
            <div className="books-body">
              <div className="book-row-top">
                {data?.books?.slice(0, 4).map((book) => (
                  <div className='book-card' key={book._id}>
                    <BookCard book={book} showPanier={true}/>
                  </div>
                ))}
              </div>
              <div className="book-row">
                {data?.books?.slice(4).map((book) => (
                  <div className='book-card' key={book._id}>
                    <BookCard book={book} showPanier={true} />
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="book-row">
              {data?.books?.map((book) => (
                <div className='book-card' key={book._id}>
                  <BookCard book={book} showPanier={true} />
                </div>
              ))}
            </div>
          )}
          <Paginate pages={data.pages} page={data.page} basePath="/livres" />
        </Container>
      )}
    </div>
  );
};

export default BooksScreen;
